<div *ngIf="label" class="input-label" [class.status-warning]="warningMessage">
	{{ label }}
	<!-- matTooltip still gives errors in this version (solved in angular material 7+ ? ) -->
	<!-- <span class="warning-message" *ngIf="warningMessage" [matTooltip]="warningMessage">
		<i class="fa fa-warning"></i>
	</span> -->
	<span class="warning-message" *ngIf="warningMessage" [title]="warningMessage">
		<i class="fa fa-warning"></i>
	</span>
</div>
<div class="input-wrapper"
	[class.status-warning]="warningMessage"
	[class.with-action-button]="useDataSource || useMacroSuggestions"
	[class.full-size]="hostStyle"
	(clickOutside)="hostStyle=null"
>
	<div *ngIf="allowMaximize" (click)="toggleFullSize()" class="toggle-size ie-icon-button" [title]="'TOGGLE_SIZE' | translate">
		<i class="fa" [class.fa-window-maximize]="!hostStyle" [class.fa-window-minimize]="hostStyle"></i>
	</div>
	<div class="ie-content" #contentWrapper (click)="onContentClick()" [title]="hideUI ? label || '' : ''">
		<ng-content></ng-content>
		<span class="suffix" *ngIf="suffix">
			{{ suffix }}
		</span>
	</div>

	<div class="action-button"
		*ngIf="useDataSource"
		[title]="'USE_DATA_SOURCE' | translate"
		[class.active]="dataSourceActive"
		(click)="onDataSourceButtonClick()"
	>
		<i class="fas fa-plug"></i>
	</div>

	<div class="action-button"
		*ngIf="useMacroSuggestions"
		[title]="'INSERT_MACRO' | translate"
		[class.active]="suggestionsOpen"
		(click)="onSuggestionsButtonClick()"
	>
		<i class="fa fa-code"></i>
	</div>

	<div class="auto-complete">
		<mat-autocomplete #matAutoComp>

			<mat-option 
				*ngFor="let option of filteredAutoCompleteOptions"
				[value]="option.value"
				
				>
				{{ option.label }}
			</mat-option>
		</mat-autocomplete>
	</div>
	<div *ngIf="useMacroSuggestions && suggestOptions?.length" class="suggestions" 
		[hidden]="!suggestionsOpen">
		<bb-entity-selector
			#suggestionES
			[(ngModel)]="suggestion"
			[options]="suggestOptions"
			[selectOnly]="true"
			(optionSelected)="suggestionSelected($event)" [ngModelOptions]="{standalone: true}"
		></bb-entity-selector>
	</div>
</div>
